/**
 * size-option-scale-target.js
 *
 * Listens for `on:size-option:change` events (dispatched by
 * size-option-logger.js) and applies the payload's `scale` factor as a
 * `transform: scale(...)` on the main gallery image link
 * (`a.block.show-gallery`) on the product page.
 *
 * The publisher and this subscriber intentionally know nothing about each
 * other beyond the event contract. Removing this file removes the visual
 * effect without touching the picker or the logger.
 */
(function () {
    "use strict";

    if (window.__briffaSizeOptionScaleTargetInstalled) return;
    window.__briffaSizeOptionScaleTargetInstalled = true;

    /** Selector for the element(s) whose transform: scale() should be updated. */
    var TARGET_SELECTOR = "a.block.show-gallery";

    /**
     * Applies the size-driven transform to every matching target:
     *   - `scale(<scale>)`                using the 0–1 multiplier
     *   - `translateY(((1 - scale) * 40)%)` 40% of the inverse of the scale
     *
     * The biggest size (scale=1) stays in place (translateY=0). Smaller
     * sizes are pushed down proportionally to how much they shrink,
     * scaled by 40%, so a scale of 0.4 corresponds to translateY(24%).
     *
     * translateY is applied first so it moves the element by a percentage
     * of its ORIGINAL (pre-scale) height, keeping the vertical offset
     * predictable regardless of the current scale factor.
     */
    function applyTransform(scale, scaled) {
        if (typeof scale !== "number" || !isFinite(scale)) return;
        if (typeof scaled !== "number" || !isFinite(scaled)) return;
        // translateY intentionally omitted for now — the carousel-slider
        // dampens its own height via the same `on:size-option:change` event,
        // which takes care of vertical framing. Re-enable by restoring
        // `translateY((1 - scale) * 40)%` before the scale below.
        var targets = document.querySelectorAll(TARGET_SELECTOR);
        for (var i = 0; i < targets.length; i++) {
            targets[i].style.transform = "scale(" + scale + ")";
        }
    }

    document.addEventListener("on:size-option:change", function (e) {
        var detail = e && e.detail;
        if (!detail) return;
        applyTransform(detail.scale, detail.scaled);
    });
})();
